import { PartialEnvVarMap } from "../types/envVar";

const tourEnvVars: PartialEnvVarMap = {
  idApiUrl: "https://identity-management-tour.nonprod.vibe.justworks.com",
  oktaAppClientId: "0oamehkz4mFHAlWkW1d7",
  oktaHostUrl: "https://tour-login.justworks.com",
  oktaCommonJwGroupId: "00gmeblt6uCgUAwBP1d7",
};

export default tourEnvVars;
